import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Button from "../../../../components/Buttons/Button";
import useRating from "../../hooks/agent/useRating";
import CustomModal from "../../../../components/Modal/CustomModal";
import useReactGASend from "../../../../hooks/useReactGASend";

const Survey = ({ isOpen, onRequestClose }) => {
  const navigate = useNavigate();
  const {
    rating,
    handleRating,
    comment,
    handleCommentChange,
    submitRating,
    close,
  } = useRating();
  const { makeEventTrackFn } = useReactGASend();
  useEffect(() => {
    const preventScroll = (e) => {
      e.preventDefault();
      e.stopPropagation();
    };

    const handleFocus = () => {
      document.addEventListener("wheel", preventScroll, { passive: false });
      document.addEventListener("touchmove", preventScroll, { passive: false });
    };

    const handleBlur = () => {
      document.removeEventListener("wheel", preventScroll);
      document.removeEventListener("touchmove", preventScroll);
    };

    const textarea = document.querySelector("textarea");
    if (textarea) {
      textarea.addEventListener("focus", handleFocus);
      textarea.addEventListener("blur", handleBlur);
    }

    return () => {
      if (textarea) {
        textarea.removeEventListener("focus", handleFocus);
        textarea.removeEventListener("blur", handleBlur);
      }
    };
  }, []);

  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="디지털상담 상담원 채팅 설문"
    >
      <p className="text-2xl font-semibold text-center mb-11">
        상담은 <br />
        친절하고 적극적인 태도로 <br />
        안내해 드렸나요?
      </p>
      <div className="grid grid-cols-5 mb-4 rating rating-lg justify-items-center">
        {[1, 2, 3, 4, 5].map((star) => (
          <label key={star}>
            <input
              type="radio"
              name="rating-8"
              className={`mask mask-star ${
                rating >= star ? "bg-purple-c-900" : "bg-purple-300"
              }`}
              checked={rating === star}
              onChange={() => handleRating(star)}
            />
          </label>
        ))}
      </div>
      <div className="grid grid-cols-5 mb-5 text-sm font-semibold text-center text-neutral-600">
        <p>매우불만</p>
        <p>불만</p>
        <p>보통</p>
        <p>만족</p>
        <p>매우만족</p>
      </div>
      <div className="mb-10">
        <textarea
          placeholder="개선 필요한 내용을 알려주세요(선택)"
          className="w-full bg-transparent text-base textarea textarea-bordered textarea-lg"
          value={comment}
          onChange={handleCommentChange}
        ></textarea>
      </div>
      <div className="flex gap-2">
        <Button
          size="sm"
          onClick={() => {
            close();
          }}
          cancle
        >
          설문종료
        </Button>
        <Button
          size="sm"
          onClick={() => {
            makeEventTrackFn({
              category: "event",
              action: "고객 평가",
              body: {
                data_rating: rating,
                data_rate_msg: comment,
              },
            });
            submitRating();
          }}
        >
          설문제출
        </Button>
      </div>
    </CustomModal>
  );
};

export default Survey;
